export { default } from "./ContactBox";
